import React from 'react';
import PropTypes from 'prop-types';

import FluidBackgroundImg from 'Components/Utility/FluidBackgroundImg';

export default function SplashHeader({ title, subtitle }) {
  return (
    <FluidBackgroundImg
      src="About-Us-Community-Order-Page-TAKEOVER-BACKGROUND-NEW-SIZE.jpg"
      folder="assets"
      subfolder="banners/takeover"
      className="fanatical-splash-header"
      tagName="header"
      heights={{ xs: 120, sm: 120, md: 143, lg: 170, xl: 170, xxl: 200 }}
      fit="crop"
    >
      <div className="header-area">
        <h1>
          <span>
            {title}
          </span>
        </h1>
      </div>
      {subtitle &&
        <div className="subheader-area">
          <p>
            <span>
              {subtitle}
            </span>
          </p>
        </div>
      }
    </FluidBackgroundImg>
  );
}

SplashHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

SplashHeader.defaultProps = {
  title: '',
  subtitle: '',
};
